/* iFurb mail-in service fee lock.
   Keeps the "Mail-in service fee" line at exactly 1 when the cart holds any fee-bearing
   "Mail-in service" product, and at 0 when it holds none (the 6th->7th gen upgrade never needs it). */
(function () {
  var cfgEl = document.getElementById('mib-fee-lock-config');
  if (!cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);
  if (!cfg.feeVariantId) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var running = false, again = false, timer = null;

  function json(url, body) {
    return nativeFetch(root + url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json(); });
  }

  function refreshUi() {
    var onCartPage = !!document.getElementById('Cart');
    if (onCartPage) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return;
    }
    var last = parseInt(sessionStorage.getItem('mibFeeLockReload') || '0', 10);
    if (Date.now() - last > 5000) {
      sessionStorage.setItem('mibFeeLockReload', String(Date.now()));
      window.location.reload();
    }
  }

  function check() {
    if (running) { again = true; return; }
    running = true;
    json('cart.js').then(function (cart) {
      var needsFee = cart.items.some(function (i) {
        return i.product_type === cfg.productType && i.variant_id !== cfg.feeVariantId && cfg.noFeeHandles.indexOf(i.handle) === -1;
      });
      var fees = cart.items.filter(function (i) { return i.variant_id === cfg.feeVariantId; });
      var qty = fees.reduce(function (n, i) { return n + i.quantity; }, 0);
      var target = needsFee ? 1 : 0;
      if (qty === target && fees.length <= 1) return false;
      if (!fees.length) return json('cart/add.js', { items: [{ id: cfg.feeVariantId, quantity: 1 }] }).then(function () { return true; });
      var updates = {};
      fees.forEach(function (f, i) { updates[f.key] = i === 0 ? target : 0; });
      return json('cart/update.js', { updates: updates }).then(function () { return true; });
    }).then(function (changed) {
      if (changed) refreshUi();
    }).catch(function () {}).then(function () {
      running = false;
      if (again) { again = false; schedule(); }
    });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(check, 350); }

  // Re-check after any cart mutation made by the theme.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(schedule, schedule);
    return p;
  };
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.action && /\/cart/.test(e.target.action)) schedule();
  }, true);
  window.addEventListener('pageshow', schedule);
  schedule();
})();
